/**
 * Converts a string with line breaks into HTML paragraphs
 * @param text - The text to transform
 * @returns HTML string with paragraphs
 */
export const parseTextToHtmlParagraphs = (text: string | undefined): string => {
  if (!text || typeof text !== 'string') {
    return ''
  }

  if (text.includes('<') && text.includes('>')) {
    return text
  }

  return text
    .split('\n')
    .filter(line => line.trim() !== '')
    .map(line => `<p>${line.trim()}</p>`)
    .join('')
}
